// AvaliacaoEditorial.js — o que a EDITORA diz do livro enquanto nenhum leitor
// o avaliou (18/10/2026).
//
// INTEGRADA À LISTA (18/10/2026, pedido do dono): cada comentário tem a mesma
// cara de um comentário de leitor (foto, nome, texto, divisória) e entra na
// mesma lista, sem moldura nem aviso em cima. Nome, estrelas e data vêm do
// servidor e se mudam no painel; as estrelas são só desenho e o comentário
// continua fora da média e da contagem. O que NÃO muda é a identificação:
// a foto é a marca da editora e a plaquinha "Editora" fica ao lado do nome,
// seja qual for o nome. Sem isso, o texto da editora passaria por opinião
// espontânea de leitor, e isso é publicidade dissimulada (CDC, art. 36).
//
// Quem decide se aparece é o servidor (AvaliacaoEditorialService): a primeira
// avaliação real de um leitor tira tudo daqui sozinha, e o painel desliga por
// livro ou de uma vez.
import React from "react";
import marca from "../../../assets/imgs/logo (1).png";
import Stars from "./Stars";

const fmtData = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T12:00:00");
  return isNaN(d) ? "" : d.toLocaleDateString("pt-BR");
};

// A marca da editora no lugar da foto de perfil, no mesmo tamanho da foto de
// um leitor (FotoPessoa w-9 h-9), para a linha ficar alinhada com as outras.
const FotoDaEditora = () => (
  <span
    className="w-9 h-9 shrink-0 inline-flex items-center justify-center rounded-full bg-insigne-orange"
    aria-hidden="true"
  >
    <img src={marca} alt="" className="w-[58%] h-auto" draggable="false" />
  </span>
);

const AvaliacaoEditorial = ({ itens }) => {
  if (!itens || itens.length === 0) return null;

  return (
    <div className="space-y-5 mb-6">
      {itens.map((c) => (
        <div key={c.id} className="border-b border-line pb-[1.25rem] last:border-0">
          <div className="flex items-center gap-2.5 flex-wrap">
            <FotoDaEditora />
            <span className="font-bold text-sm">{c.nome || "Editora Insigne Acadêmica"}</span>
            {/* Mesma forma das outras plaquinhas (`.selo`), no tom vazado do
                "Assinante": discreta, mas lida de relance. */}
            <span
              className="selo text-insigne-orange border border-insigne-orange/45 bg-insigne-orange/10"
              title="Comentário escrito pela Editora Insigne Acadêmica"
            >
              <i className="bi bi-patch-check-fill" />
              Editora
            </span>
          </div>
          <div className="flex items-center gap-2 mt-1.5 text-xs text-white/50">
            <Stars value={c.nota || 5} size="text-xs" />
            <span>{fmtData(c.data)}</span>
          </div>
          <p className="text-white/80 text-sm mt-2 leading-relaxed whitespace-pre-line">{c.texto}</p>
        </div>
      ))}
    </div>
  );
};

export default AvaliacaoEditorial;
